// Uzbek translations
export const uz: Record<string, string> = {
  'menu.dashboard': 'Boshqaruv paneli',
  'menu.customers': 'Mijozlar',
  'menu.products': 'Mahsulotlar',
  'menu.users': 'Foydalanuvchilar',
  'menu.settings': 'Sozlamalar',
  'menu.logout': 'Chiqish',
  'dashboard.title': 'Boshqaruv paneli',
  'dashboard.newOrder': 'Yangi buyurtma',
  'order.title': 'Yangi buyurtma',
  'order.customer': 'Mijoz',
  'order.products': 'Mahsulotlar',
  'order.total': 'Jami',
  'users.title': 'Foydalanuvchilar',
  'users.name': 'Ism',
  'users.email': 'Elektron pochta',
  'common.yes': 'Ha',
  'common.no': 'Yoq',
  'common.cancel': 'Bekor qilish',
  'common.save': 'Saqlash',
  'common.search': 'Qidirish',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Kirish',
  'login.welcome': 'Xush kelibsiz, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Elektron pochta',
  'signup.phone': 'Telefon',
  'menu.reportsAndAccounting': 'Hisobotlar va buxgalteriya',
  'menu.systemAndCommunication': 'Tizim va aloqa',
};